import { z } from 'zod';
import { coordinateSchema, sizeSchema } from '../../../Shared.js';

const imageItemSchema = z.object({
  kind: z.literal("image"),
  id: z.string(),
  src: z.string(),
  thumbnail: z.string().optional(),
  fileName: z.string(),
  updatedAt: z.number().default(Date.now()),
  position: coordinateSchema,
  size: sizeSchema,
  naturalSize: sizeSchema,
  angleInRadian: z.number(),
  settings: z.object({
    cloneable: z.boolean().default(false),
    movable: z.boolean().default(false),
    showCrediting: z.boolean().default(false),
    hideDragHandle: z.boolean().optional()
  }).default({}),
  crediting: z.object({
    title: z.string(),
    description: z.string(),
    author: z.string(),
    creditLine: z.string(),
    year: z.string()
  })
});

export { imageItemSchema };
//# sourceMappingURL=Image.js.map
